module.exports = __webpack_public_path__ + "img/2-5.dd75929b.svg";